export const appPaths = {
    DASHBOARD: "/",
    DASHBOARD_MAIN: "/index"
}